import React from "react";
import classnames from "classnames";
import { FormattedMessage } from "react-intl";

import { useCollapseContext } from "@sportal/cdk/collapsibleSection";
import { ShowToggle } from "../../../../components/showToggle/ShowToggle";

import "./CollapsibleSectionHeader.scss";

interface CollapsibleSectionHeaderProps {
  clickableHeader: React.ReactNode;
  staticHeader?: React.ReactNode;
  description: React.ReactNode;
  disabled?: boolean;
}

export const CollapsibleSectionHeader = ({
  clickableHeader,
  staticHeader,
  description,
  disabled,
}: CollapsibleSectionHeaderProps) => {
  const { getToggleProps, opened } = useCollapseContext();

  const toggleProps = !disabled ? getToggleProps({ type: "div" }) : {};

  return (
    <div
      className={classnames("collapsible-section-header", {
        "collapsible-section-header--opened": opened,
        "collapsible-section-header--disabled": disabled,
      })}
    >
      <div className="collapsible-section-header__title">
        <div
          {...toggleProps}
          className="collapsible-section-header__title--clickable"
        >
          <ShowToggle isOpen={opened} />
          {clickableHeader}
          <span className="sr-only">
            <FormattedMessage id="aria_section" />
          </span>
        </div>
        {staticHeader}
      </div>

      <div className="collapsible-section-header__description">
        {description}
      </div>
    </div>
  );
};
